__turbopack_context__.v({
  "blogDescription": "YuIbtq_blogDescription",
});
